import moment from "moment";

export const localDate = (date) => moment(date).local().format('MM-DD-YYYY');